inputs-daterange
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      input(class="form-control { opts.klass }" placeholder="{ opts.placeholder }" type="text" onChange="{this.onChange}" data-type="date")
      input(name="{ opts.name }" type="hidden" value="{ opts.value }")
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.daterange');
  style(scoped).
    input.form-control {
      display: inline-block;
      width: auto;
      min-width: 12rem;
    }
